<nav id="header-navbar"
     class="navbar navbar-expand-sm fixed-top navbar-nav">
     <div class="loading-bar-container">
        <ngx-loading-bar [includeSpinner]="false"
                         [fixed]="false"
                         color="#63a386"
                         height="6px"></ngx-loading-bar>
    </div>
</nav>
